import { render } from "./CustomItemNoteInterface.vue?vue&type=template&id=0a6d071a"
import script from "./CustomItemNoteInterface.vue?vue&type=script&lang=js"
export * from "./CustomItemNoteInterface.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__